import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { ConfigProvider, theme } from 'antd';
import Layout from "./Layout";
import Dashboard from "./pages/Dashboard";
import './styles/App.css'; // Import the CSS file

const { darkAlgorithm } = theme;

const App = () => {
  const isDarkMode = true;

  useEffect(() => {
    document.body.style.backgroundColor = '#1d1d1d';
    document.body.style.color = '#ffffff';
  }, []);

  return (
    <ConfigProvider
      theme={{
        algorithm: darkAlgorithm,
      }}
    >
      <Router>
        {/* <Layout /> */}
        <Routes>
          <Route path="/" element={<Dashboard />} />
        </Routes>
      </Router>
    </ConfigProvider>
  );
};

export default App;
